
import { Component, Vue, Watch } from "vue-property-decorator";
import { ScanforGetOnModule } from "@/store/modules/store_scanforgeton";

@Component({
  name: "Form2"
})
export default class extends Vue {
  @Watch("formmodel2", { deep: true })
  onChildChanged(val: string) {
    this.$emit("get-form2-value", val);
  }
  mounted() {
    this.InitConfig();
    this.formmodel2.checked_NeedWeight = true;
  }
  get AutoCreateCarCodeOldFlag(){
    return ScanforGetOnModule.checked_AutoCreateCarCodeOld;
  }
  private AutoCreateCarCodeChangeFunc(isChecked) {
    ScanforGetOnModule.AutoCreateCarCodeOldChangeState(isChecked);
    this.$emit("auto-create-car-code-change", isChecked);
  }
  public InitConfig() {
    var _configData: configData = obj_ScanForGetOn.getScanForGetOnConfig();
    this.AutoCreateCarCodeShow = !_configData.isAutoCreateCarCodeShow;
    this.formmodel2.checked_IsSumWeight = _configData.isSumWeightChecked;
  }
  private AutoCreateCarCodeShow: Boolean = true;
  private formmodel2 = {
    checked_IsSumWeight: false,
    checked_IsOverTimeCar: false,
    checked_AutoCreateCarCode: false,
    checked_NeedWeight: false
  };
}
